<template>

</template>

<script>

export default {
  name: "TerminalModal",
  props: {
    alertText: {
      default: ""
    },
    confirmText: {
      default: "OK"
    },
    cancelText: {
      default: "CANCEL"
    },
    cancelable: {
      default: false
    },
    icon: {
      default: "warning"
    }
  },
  methods: {
    open() {
      this.$swal({
        title: '',
        text: this.alertText || 'Are you sure?',
        type: this.icon,
        showCancelButton: this.cancelable,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.confirmText,
        cancelButtonText: this.cancelText
      }).then((result) => {
        if (result.value) {
          this.$emit("confirm");
        } else {
          this.$emit("cancel");
        }
      })
    },
    close() {
    }
  }
};

</script>
